export default __webpack_public_path__ + "8f98f951c7dafd566e8a44af2ee40909.svg";